module.exports = __webpack_public_path__ + "img/fruit-citrus-190x100.09beb2c4.jpg";